module.exports = ".MainNav{background:#A11D21;position:relative}\n"